exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-dialog .el-dialog {\n  margin-top: 3vh !important;\n}\n", ""]);

// exports
